import { render, staticRenderFns } from "./InstaStreamEmbed.vue?vue&type=template&id=64074c4c&scoped=true"
import script from "./InstaStreamEmbed.vue?vue&type=script&lang=js"
export * from "./InstaStreamEmbed.vue?vue&type=script&lang=js"
import style0 from "./InstaStreamEmbed.vue?vue&type=style&index=0&id=64074c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64074c4c",
  null
  
)

export default component.exports